import { gql } from '@apollo/client';

export const GET_DSP_DELIVERY_COMPLETED_DETAIL_PAGE_LIST = gql`
  query GetDspDeliveryCompletedDetailPageList($pageRequest: DspDeliveryCompletedDetailPageRequestTypeInput!) {
    getDspDeliveryCompletedDetailPageList(pageRequest: $pageRequest) {
      pageResponse {
        content {
          id
          trackingNumber
          deliveredDate
          hubName
          warehouseName
          areaName
          dspName
          dspFullName
          driverName
          driverPhone
          lastTaskDate
          standardizedAddress
          isHalfPriceAddress
          deliverySequence
          isHalfPriceOrder
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export interface DspDeliveryCompletedDetailType {
  id: number;
  trackingNumber: string;
  deliveredDate: string;
  hubName?: string | null;
  warehouseName?: string | null;
  areaName?: string | null;
  dspName?: string | null;
  dspFullName?: string | null;
  driverName?: string | null;
  driverPhone?: string | null;
  lastTaskDate?: string | null;
  standardizedAddress?: string | null;
  isHalfPriceAddress: boolean;
  deliverySequence?: number | null;
  isHalfPriceOrder: boolean;
}

export interface DspDeliveryCompletedDetailFilterType {
  deliveredDateStart: string;
  deliveredDateEnd: string;
  deliveredDate?: string | null;
  hubId?: number | null;
  warehouseId?: number | null;
  areaId?: number | null;
  driverId?: number | null;
  isHalfPriceOrder?: boolean | null;
}

export interface DspDeliveryCompletedDetailPageRequestType {
  filter: DspDeliveryCompletedDetailFilterType;
  pageRequest: {
    page: number;
    size: number;
    sortBy?: string | null;
    sortDirection?: string | null;
  };
}

export interface DspDeliveryCompletedDetailPageResponseData {
  content: DspDeliveryCompletedDetailType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface DspDeliveryCompletedDetailPageResponseType {
  pageResponse: DspDeliveryCompletedDetailPageResponseData;
}

export interface GetDspDeliveryCompletedDetailPageListResponse {
  getDspDeliveryCompletedDetailPageList: DspDeliveryCompletedDetailPageResponseType;
}

